import { render } from "./AddModelContrat.vue?vue&type=template&id=cfffb1e8&ts=true"
import script from "./AddModelContrat.vue?vue&type=script&lang=ts"
export * from "./AddModelContrat.vue?vue&type=script&lang=ts"

import "./AddModelContrat.vue?vue&type=style&index=0&id=cfffb1e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__